import FormCheckbox from '@/components/molecules/FormCheckbox';
import { SearchFilterGeneralProps } from '../SearchFilterGeneralInfoSection/SearchFilterGeneralInfoSection';

const conditionOptions = [
  { label: 'New', value: 'New' },
  { label: 'Pre-owned', value: 'Used' },
];

export const SearchFilterConditionSection: React.FC<
  SearchFilterGeneralProps
> = ({ updateFilter, filters }) => {
  return (
    <section className="flex flex-col gap-s pt-s">
      <label className="text-body2Regular text-neutral-800">
        <span className="block">Vehicle title</span>
      </label>
      {conditionOptions.map((option, index) => {
        return (
          <FormCheckbox
            key={index}
            className="flex w-full items-center justify-start rounded-[8px] bg-neutral-100 px-l py-m hover:bg-neutral-200"
            checkBoxStyle="size-[20px] border-[1px] rounded-xsmall"
            onChange={(evt) => {
              let conditionArray = filters.condition
                ? filters.condition.split(',')
                : [];
              if (evt) {
                conditionArray.push(option.value);
              } else {
                conditionArray = conditionArray.filter(
                  (condition) => condition !== option.value
                );
              }
              updateFilter({
                fields: {
                  condition: conditionArray.join(','),
                },
              });
            }}
            checked={filters.condition.includes(option.value)}
            checkboxLabel={option.label}
          />
        );
      })}
    </section>
  );
};
